var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurplePaperPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6175 17.449L19.2472 9.5603C20.2958 6.4145 20.8201 4.84161 19.9898 4.01133C19.1595 3.18105 17.5866 3.70535 14.4406 4.75395L6.60242 7.36659C4.85368 7.94948 3.97932 8.24093 3.71392 8.88211C3.65154 9.03281 3.61382 9.19257 3.60222 9.35525C3.55284 10.0474 4.20456 10.6991 5.50799 12.0025L5.7454 12.2399C5.95934 12.4538 6.06631 12.5608 6.14718 12.6799C6.30667 12.9147 6.3972 13.1895 6.40851 13.4732C6.41425 13.617 6.39179 13.7666 6.34688 14.0658C6.18251 15.161 6.10032 15.7086 6.19714 16.1299C6.39013 16.9698 7.04024 17.6291 7.87737 17.8339C8.29735 17.9367 8.84605 17.8622 9.94346 17.7133L10.0035 17.7051C10.3128 17.6631 10.4675 17.6422 10.616 17.6511C10.8856 17.6674 11.146 17.7552 11.3704 17.9055C11.494 17.9883 11.6044 18.0987 11.8252 18.3194L12.0362 18.5305C13.3049 19.7991 13.9392 20.4334 14.6121 20.4003C14.7976 20.3912 14.9798 20.3482 15.1498 20.2734C15.7665 20.002 16.0501 19.151 16.6175 17.449Z",
    stroke: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 16.7969L19.2002 4.79688",
    stroke: "#A020FF",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePaperPlane);
export default __webpack_public_path__ + "static/media/PurplePaperPlane.0d2b878611d15dd5cf80d2404d3a6691.svg";
export { ForwardRef as ReactComponent };